module.exports = __webpack_public_path__ + "img/Anne Frances Sangil.ff0ff7c6.jpg";